import AddressbarColor from 'quasar/src/plugins/AddressbarColor.js';
import { boot } from 'quasar/wrappers'

export default boot(() => {
  AddressbarColor.set('#1D1D1D')
})
